import useSWR from "swr";
import useUnit from "../../customHooks/useUnit";
import { customFetcher, extractReactTableData, fileDownload } from "../../utils";
import VirtualTable from "../../components/custom/VirtualTable";
import styled from "styled-components";
import ActionIcon from "../../components/custom/ActionIcon";
import { useRef } from "react";
import moment from "moment";
import Layout from "../../components/custom/Layout";

interface Data {
    expiration_date: Date | string;
    file_type: string;
    first_name: string;
    last_name: string;
    email: string;
    days_left: number;
}

export default function ExpiringDocs() {

    const s_unit = useUnit();
    const {
        data
    } = useSWR(`/expiring-docs/${s_unit}`, customFetcher<Data>, {
        fallbackData: []
    });
    const tableRef = useRef();
    const handleDownload = () => {
        const data = extractReactTableData(tableRef, ['index']);
        fileDownload(data, `Expiring Docs ${moment().format('YYYY-MM-DD')}`);
    }

    return (
        <Layout>
            <FlexContainer>
                <h3>Documents that are going to expire in 30 days</h3>
                <ActionIcon
                    type={'download'}
                    onClick={handleDownload}
                />
            </FlexContainer>
            <VirtualTable<Data>
                data={data}
                mapping={[{
                    name: 'Days Left',
                    value: 'days_left',
                    number: true
                }, {
                    name: 'Expiration Date',
                    value: 'expiration_date',
                    date: true,
                    utc: true
                }, {
                    name: 'Document Type',
                    value: 'file_type'
                }, {
                    name: 'First Name',
                    value: 'first_name'
                }, {
                    name: 'Last name',
                    value: 'last_name'
                }, {
                    name: 'Email',
                    value: 'email'
                }]}
                reactTableRef={tableRef}
                numRows={25}
            />
        </Layout>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;